import * as React from 'react'
import { IntlProvider } from 'react-intl'
import { LocaleProvider } from 'antd'
import { currentLocale, locales } from '../config/locales'

class I18nWrapper extends React.Component<any> {
  render() {
    const { children } = this.props
    const locale = currentLocale()
    const antdLocale = locales.antd[locale]

    return (
      <LocaleProvider locale={antdLocale}>
        <IntlProvider key={locale} locale={locale} messages={locales.local[locale]}>
          <div>{ children }</div>
        </IntlProvider>
      </LocaleProvider>
    )
  }
}

export default I18nWrapper
